import { render, staticRenderFns } from "./Plus.vue?vue&type=template&id=1ed479a6&"
import script from "./Plus.vue?vue&type=script&lang=ts&"
export * from "./Plus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports